export default __webpack_public_path__ + "static/media/edit_white.94be1679.svg";